module.exports = __webpack_public_path__ + "static/media/tui_news.7cef13d5.jpg";